import * as types from 'src/store/types';

export default {
  namespaced: true,
  state: {
    loading: false,
  },
  getters: {},
  mutations: {
    [types.SET_ESTIMATE_LOADING](state, loading) {
      state.loading = loading;
    },
  },
  actions: {},
};
